module.exports = __webpack_public_path__ + "static/img/print_tela_agenda.4c12210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/print_tela_agenda.png
// module id = QEFk
// module chunks = 0